
  import { defineComponent } from 'vue';
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';

  interface ImageModalProps {
    item: Record<string, string>;
    active: boolean;
  }

  export default defineComponent<ImageModalProps>({
    components: { ImageAsset },
    props: ['item', 'active'],
    emits: ['close'],
  });
